const ACTION = {
  AUX_PAYMENT: {
    PENDING: 'AUX_PAYMENT_PENDING',
    SUCCESS: 'AUX_PAYMENT_SUCCESS',
    FAILURE: 'AUX_PAYMENT_FAILURE',
    UPDATE: 'AUX_PAYMENT_UPDATE',
  },
}

export const AUX_PAYMENT_STATE = {
  REFRESHED: 'AUX_PAYMENT_REFRESHED',
  IN_PROGRESS: 'AUX_PAYMENT_PROGRESS',
  SUCCESS: 'AUX_PAYMENT_RETRIEVED',
  ERROR: 'AUX_PAYMENT_ERROR',
  PENDING: 'AUX_PAYMENT_PENDING',
}

export default ACTION
